import { VisibilitySetCta } from 'core/ribbons/cta';
import { useVisibilitySetsAction } from 'presentation/context/VisibilitySets';

export default () => {
  const setVisibility = useVisibilitySetsAction();

  return ({ behavior }: { behavior?: VisibilitySetCta }) => {
    if (setVisibility != null) {
      setVisibility(behavior?.visibilitySet);
    }
  };
};
